import { render, staticRenderFns } from "./SupplierProductsList.vue?vue&type=template&id=6747e3e6&scoped=true"
import script from "./SupplierProductsList.vue?vue&type=script&lang=js"
export * from "./SupplierProductsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6747e3e6",
  null
  
)

export default component.exports